import { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import usePostContactUs from 'hooks/useContactUs';
import Input from 'components/system/Input';
import useUserData from './useUserData';

const validationSchema = yup.object({
  firstName: yup.string().required('Your firstname is required'),
  lastName: yup.string().required('Your lastname is required'),
  email: yup
    .string()
    .email('Your email is not valid')
    .required('Your email is required'),
  phone: yup.string(),
  feedback: yup.string(),
});

const formInputs = [
  {
    name: 'firstName',
    label: 'First Name*',
    placeholder: 'First Name',
    grid: true,
  },
  {
    name: 'lastName',
    label: 'Last Name*',
    placeholder: 'Last Name',
    grid: true,
  },
  {
    name: 'email',
    label: 'Email Address*',
    placeholder: 'Email Address',
    grid: true,
  },
  {
    name: 'phone',
    label: 'Phone',
    placeholder: '+ 0 (000) 000-0000',
    grid: true,
  },
  {
    name: 'feedback',
    label: 'How can we help?',
    placeholder: 'Type your message here...',
  },
];

const ContactUsForm = () => {
  const [feedbackIsSent, setFeedbackIsSent] = useState(false);
  const { firstName, lastName, email } = useUserData();
  const { mutate, error } = usePostContactUs();

  const formik = useFormik({
    initialValues: {
      firstName,
      lastName,
      email,
      phone: '',
      feedback: '',
    },
    validationSchema,
    onSubmit: async (values) => {
      setFeedbackIsSent(true);
      mutate(values);
    },
  });

  return (
    <>
      <Grid container direction="row" spacing={2}>
        {
          formInputs.map(({ grid, name, ...config }, i) => (
            <Grid item md={grid ? 6 : 12} direction="column" sx={{ marginBottom: '12px' }}>
              <Input
                {...config}
                autoComplete="off"
                key={name}
                value={formik.values[name]}
                error={formik.errors[name]}
                name={name}
                onChange={formik.handleChange}
                sx={{ height: '100%' }}
              />
            </Grid>
          ))
        }
      </Grid>
      <Button
        onClick={formik.handleSubmit}
        fullWidth
        variant="contained"
        type="primary"
        sx={{ marginTop: '16px', width: '100px' }}
        disabled={!formik.isValid}

      >
        Submit
        {/* {loading && <Loading />} */}
      </Button>
    </>
  );
};

export default ContactUsForm;
